import React from "react";

import { ImageProps, VideoProps } from "@touchtech/baselayer-ui";

import { CacheEntryPriority } from "@is/services/MemoryCache";

import { MediaType, MediaVariant } from "../../types";
import { isVideo } from "../../utils";
import { Image } from "../Image";
import { Video } from "../Video";

type Props = {
  media: MediaType;
  mediavariant: MediaVariant;
  alt?: string;
  layout?: ImageProps["layout"] | VideoProps["layout"];
  children?: React.ReactNode;
  priority?: CacheEntryPriority;
  showloadingspinner?: boolean;
};

function Media({
  media,
  mediavariant,
  alt,
  children,
  layout = "cover",
  priority,
  showloadingspinner,
}: Props) {
  if (isVideo(media)) {
    return (
      <Video
        alt={alt}
        src={media.url}
        type={media.contentType}
        layout={layout}
        mediavariant={mediavariant}
        showloadingspinner={showloadingspinner}
      >
        {children}
      </Video>
    );
  } else {
    return (
      <Image
        alt={alt}
        src={media.url}
        layout={layout}
        mediavariant={mediavariant}
        priority={priority}
        showloadingspinner={showloadingspinner}
      >
        {children}
      </Image>
    );
  }
}

export default React.memo(Media, (prev, next) => {
  return (
    prev.media === next.media &&
    prev.mediavariant === next.mediavariant &&
    prev.alt === next.alt &&
    prev.layout === next.layout
  );
});
